import React from 'react';
import cx from 'classnames';

import { RadioButton } from './RadioButton';

interface Props {
    disabled?: boolean;
    direction?: RadioGroupDirection;
    legendText?: string;
    options: RadioButtonOption[];
    setValue(value: RadioButtonValue): void;
    value: RadioButtonValue;
}

/**
 * A mapping of <RadioButton>s whose `checked` state is controlled by a parent component.
 */
export const RadioButtonGroup = ({
    disabled = false,
    direction = 'vertical',
    legendText,
    options,
    setValue,
    value,
}: Props): JSX.Element => (
    <fieldset
        className={cx('flex', {
            'flex-col': direction === 'vertical',
        })}
    >
        {legendText && <legend>{legendText}</legend>}
        {options.map(
            (option: RadioButtonOption): JSX.Element => (
                <RadioButton
                    disabled={disabled}
                    key={option.inputId}
                    groupDirection={direction}
                    handleChange={({
                        checked,
                        value: nextValue,
                    }: RadioButtonUpdate): void => {
                        if (checked) {
                            setValue(nextValue);
                        }
                    }}
                    isChecked={option.value === value}
                    option={option}
                />
            ),
        )}
    </fieldset>
);
